import { useCallback, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDrmTableDataSuccess, setDrmUpdatedTableData, setOriginalRowData, setRowModified, clearModifications } from "../redux/reducers/drmTableDataSlice";

export const useUpdateTableData = ({
  onPageRef,
  pageSizeRef,
  totalPagesRef,
  totalRecordsRef,
  tableData,
}) => {
  const { selectedMenu } = useSelector((state) => state.selectedMenu);
  const dispatch = useDispatch();
  const selectedMenuRef = useRef(selectedMenu);
  
  useEffect(() => {
    selectedMenuRef.current = selectedMenu;
  }, [selectedMenu]);

  const tableDataRef = useRef(tableData);

  useEffect(() => {
    tableDataRef.current = tableData;
  }, [tableData]);

  const updateData = useCallback(
    (rowIndex, columnId, value) => {
      const currentTableData = tableDataRef.current;
      const currentRow = currentTableData[rowIndex];
      
      if (!currentRow) return;
      
      const tableType = selectedMenuRef.current === "daily_maintenance" ? "drmDailyTableData" : "drmBidTableData";
      const sagaId = currentRow?.sagaId;
      const uniqueId = sagaId || `new_record_${rowIndex}`;

      dispatch(setOriginalRowData({
        tableType,
        uniqueId,
        rowData: { ...currentRow },
      }));


      const updatedRow = {
        ...currentRow,
        [columnId]: value,
      };

      const newData = [...currentTableData];
      newData[rowIndex] = updatedRow;

      dispatch(setRowModified({
        tableType,
        uniqueId,
        isModified: true,
      }));

      dispatch(
        setDrmTableDataSuccess({
          onPage: onPageRef.current,
          pageSize: pageSizeRef.current,
          drmMaintenanceDetails: newData,
          totalPages: totalPagesRef.current,
          totalRecords: totalRecordsRef.current,
          tableType,
        })
      );
      if (sagaId) {
        dispatch(
          setDrmUpdatedTableData({
            tableType,
            drmUpdatedMaintenanceDetails: {
              [sagaId]: [{ [columnId]: true }],
            },
          })
        );
      }
    },
    [onPageRef, pageSizeRef, totalPagesRef, totalRecordsRef]
  );

  const resetModifications = useCallback(() => {
    const tableType = selectedMenuRef.current === "daily_maintenance" ? "drmDailyTableData" : "drmBidTableData";
    dispatch(clearModifications({ tableType }));
  }, []);

  return {
    updateData,
    resetModifications,
  };
};
